module.exports = import("https://d3js.org/d3.v5.min.js");;